import { useEffect, useState } from 'react';
import { CreateUserProjectRequestPayload, UserProjectRequest } from 'services/person/request/request.types';
import { useCreateUserProjectRequestMutation, useGetUserProjectRequestMutation, useUpdateUserProjectRequestMutation } from 'services/person/request/request.endpoint';
import { useNavigate, useParams } from 'react-router-dom';
import { useApiToast } from 'components/Toaster';
export default function usePersonProjectRequestFormVM() {
    const [_, setIsSuccess] = useState<boolean>(false);
    const { showErrorToast, showApiToast } = useApiToast();

    const navigate = useNavigate();
    const { projectId, personId, requestId } = useParams();
    const isEdit = !!requestId;

    const [lastCreatedRequestLabel, setLastCreatedRequestLabel] = useState<string>('');
    const [lastUpdatedRequestLabel, setLastUpdatedRequestLabel] = useState<string>('');

    const [request, setRequest] = useState<UserProjectRequest>();


    const [
        getUserProjectRequest,
        {
            isLoading: isGetUserProjectRequestLoading,
            isError: isGetUserProjectRequestError,
            isSuccess: isGetUserProjectRequestSuccess,
            error: userProjectRequestError,
            data: userProjectRequestResponse
        }
    ] = useGetUserProjectRequestMutation();

    useEffect(() => {
        if (projectId && requestId) {
            getUserProjectRequest({ id: parseInt(projectId), requestId: parseInt(requestId) });
        }
    }, [projectId, requestId, getUserProjectRequest]);

    useEffect(() => {
        if (isGetUserProjectRequestLoading) return;
        if (isGetUserProjectRequestError && userProjectRequestError) {
            showErrorToast(userProjectRequestError, {
                message: 'Erreur de chargement de la demande de projet'
            });
            return;
        }
        if (isGetUserProjectRequestSuccess && userProjectRequestResponse) {
            setRequest(userProjectRequestResponse.data);
            return;
        }
    }, [isGetUserProjectRequestLoading, isGetUserProjectRequestError, isGetUserProjectRequestSuccess, userProjectRequestError, userProjectRequestResponse, showErrorToast]);


    const [
        createUserProjectRequest,
        {
            isLoading: isCreateLoading,
            isError: isCreateError,
            isSuccess: isCreateSuccess,
            error: projectRequestsError,
            data: projectRequestsResponse
        }
    ] = useCreateUserProjectRequestMutation();

    const [
        updateUserProjectRequest,
        {
            isLoading: isUpdateLoading,
            isError: isUpdateError,
            isSuccess: isUpdateSuccess,
            error: projectUpdateRequestsError,
            data: projectUpdateRequestsResponse
        }
    ] = useUpdateUserProjectRequestMutation();


    useEffect(() => {
        if (isCreateLoading) return;
        if (isCreateError && projectRequestsError) {
            showErrorToast(projectRequestsError, {
                message: `Erreur lors de la création de la demande de projet "${lastCreatedRequestLabel}"`
            });
        }
        if (isCreateSuccess && projectRequestsResponse) {
            showApiToast(projectRequestsResponse, {
                successMessage: `Demande de projet "${lastCreatedRequestLabel}" créée avec succès`,
                errorMessage: `Erreur lors de la création de la demande de projet "${lastCreatedRequestLabel}"`
            });
            return;
        }
    }, [isCreateLoading, isCreateError, projectRequestsError, projectRequestsResponse, isCreateSuccess, showErrorToast, lastCreatedRequestLabel, showApiToast]);

    useEffect(() => {
        if (isUpdateLoading) return;
        if (isUpdateError && projectUpdateRequestsError) {
            showErrorToast(projectUpdateRequestsError, {
                message: `Erreur lors de la mise à jour de la demande de projet "${lastUpdatedRequestLabel}"`
            });
        }
        if (isUpdateSuccess && projectUpdateRequestsResponse) {
            showApiToast(projectUpdateRequestsResponse, {
                successMessage: `Demande de projet "${lastUpdatedRequestLabel}" mise à jour avec succès`,
                errorMessage: `Erreur lors de la mise à jour de la demande de projet "${lastUpdatedRequestLabel}"`
            });
            return;
        }
    }, [isUpdateLoading, isUpdateError, projectUpdateRequestsError, projectUpdateRequestsResponse, isUpdateSuccess, showErrorToast, lastUpdatedRequestLabel, showApiToast]);

    const handleFormSubmit = (data: CreateUserProjectRequestPayload) => {
        if (!projectId) return;
        setLastCreatedRequestLabel(data.label);
        try {
            if (!isEdit) {
                createUserProjectRequest({
                    ...data,
                    projectId: parseInt(projectId)
                });
            } else if (requestId) {
                setLastUpdatedRequestLabel(data.label);
                updateUserProjectRequest({
                    ...data,
                    requestId: parseInt(requestId),
                    projectId: parseInt(projectId)
                });
            }

            setIsSuccess(true);
            navigate(`/app/admin/persons/${personId}/project/${projectId}/requests`);
        } catch (error) {
            console.error('rejected', error);
        }
    }

    return {
        handleFormSubmit, 
        isEdit, 
        request, 
        isLoading: isGetUserProjectRequestLoading || isCreateLoading || isUpdateLoading,
        projectId
    };
}
